import _ from "lodash";
import { createSelector } from "reselect";

function getPriceInfo(state) {
  return state.TourPriceInfo?.price_info ?? {};
}

export const getRoomMappingInfoSelector = createSelector(
  [getPriceInfo],
  (priceInfo) => {
    const rateInfo = priceInfo?.price?.[0]?.rate_info ?? {};

    const roomMapping = _.groupBy(
      Object.entries(rateInfo),
      ([rateCode, __]) => rateCode.split("___")[0]
    );

    return roomMapping;
  }
);
